module.exports = __webpack_public_path__ + "img/icon-44-green.88642448.svg";